<template>
  <div class="basic_wrap">
    <div class="love-card">
      <div
        class="love-title"
        @click="$router.push('/buy/1')"
      >
        {{ $t("item.loveTitle") }}
      </div>
      <div class="cert-list">
        <div class="cert-item">
          <img
            class="cert-icon car-icon"
            :src="certImages.security"
            alt=""
          >
          <div class="cert-name">
            {{ $t("item.securityCertification") }}
          </div>
        </div>
        <div class="cert-item">
          <img
            class="cert-icon"
            :src="certImages.realName"
            alt=""
          >
          <div class="cert-name">
            {{ $t("item.realNameCertification") }}
          </div>
        </div>
        <div class="cert-item">
          <img
            class="cert-icon"
            :src="certImages.confidentiality"
            alt=""
          >
          <div class="cert-name">
            {{ $t("item.confidentialityCertification") }}
          </div>
        </div>
      </div>
      <div class="game-tabs">
        <button
          v-for="item in games"
          :key="item.value"
          type="button"
          class="game-tab"
          :class="{ active: activeGame === item.value }"
          @click="selectGame(item.value)"
        >
          {{ $t(item.label) }}
        </button>
      </div>
    </div>
    <div
      class="matching-box"
      @click="$router.push('/buy/1')"
    >
      {{ $t("item.onlineMatching") }}
    </div>
    <button
      type="button"
      class="upgrade-btn"
      @click="$router.push('/buy/1')"
    >
      {{ $t("item.upgradeData") }}
    </button>
  </div>
</template>
<script>
export default {
  name: "Item",
  data() {
    return {
		islogin: false,
		activeGame: "vote",
		games: [
			{value: "vote", label: "item.voteGame"},
			{value: "game2", label: "item.game2"},
			{value: "game3", label: "item.game3"},
			{value: "game4", label: "item.game4"}
		],
		certImages: {
			security: require("../images/ban3/qc.png"),
			realName: require("../images/ban3/jd.png"),
			confidentiality: require("../images/ban3/rz.png")
		}
    };
  },
  created() {
    this.$parent.footer("item", true);
  },
  mounted() {
  	this.islogin = localStorage.getItem('token')!=null;
  	if(!this.islogin){
  		this.$router.push("/login");
  	}
  },
  methods: {
    selectGame(value) {
      this.activeGame = value;
    },
    upgradeData() {

    }
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  position: relative;
  overflow: hidden;
  padding: 180px 23px 70px;
  color: #142746;
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f9d5e6 url(../images/ban3/game1.png) no-repeat top/100% 100%;
}

.love-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 532px;
  min-height: 252px;
  margin: 0 auto;
  padding: 66px 24px 22px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.74);
  box-sizing: border-box;
}

.love-title {
  position: absolute;
  top: 22px;
  left: 50%;
  min-width: 228px;
  height: 38px;
  padding: 0 18px;
  border-radius: 22px;
  box-sizing: border-box;
  transform: translateX(-50%);
  background: #f5329e;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 38px;
  text-align: center;
  white-space: nowrap;
}

.cert-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: end;
  gap: 20px;
  margin-top: 20px;
}

.cert-item {
  min-width: 0;
  text-align: center;
}

.cert-icon {
  display: block;
  width: 58px;
  height: 58px;
  margin: 0 auto 8px;
  object-fit: contain;
}

.car-icon {
  width: 82px;
}

.cert-name {
  min-height: 38px;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  text-align: center;
  white-space: pre-line;
  word-break: keep-all;
  overflow-wrap: normal;
}

.game-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: center;
  gap: 8px;
  margin-top: 24px;
}

.game-tab {
 min-width: 0;
 height: 25px;
 padding: 0 8px;
 border: 0;
 border-radius: 22px;
 font-size: 12px;
 line-height: 25px;
 text-align: center;
 white-space: nowrap;
}

.game-tab.active {
  background: #f5329e;
  color: #fff;
  font-weight: 700;
}

.matching-box {
  position: relative;
  z-index: 1;
  width: calc(100% - 54px);
  max-width: 478px;
  height: 54px;
  margin: 24px auto 36px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.74);
  color: #172b48;
  font-size: 18px;
  line-height: 54px;
  text-align: center;
}

.upgrade-btn {
  position: relative;
  z-index: 1;
  display: block;
  width: auto;
  max-width: calc(100% - 44px);
  min-height: 48px;
  margin: 0 auto;
  padding: 0 18px;
  border: 0;
  border-radius: 28px;
  background: #f5329e;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 48px;
  white-space: nowrap;
  text-align: center;
}

@media (max-width: 420px) {
  .basic_wrap {
    padding: 180px 16px 64px;
  }

  .love-card {
    min-height: 238px;
    padding: 62px 14px 20px;
  }

  .love-title {
    min-width: 205px;
    height: 34px;
    font-size: 14px;
    line-height: 34px;
  }

  .cert-list {
    gap: 10px;
  }

  .cert-icon {
    width: 50px;
    height: 50px;
  }

  .car-icon {
    width: 72px;
  }

  .cert-name {
    font-size: 14px;
    line-height: 17px;
  }

  .game-tabs {
    gap: 4px;
    margin-top: 22px;
  }

  .game-tab {
    height: 36px;
    padding: 0 6px;
    font-size: 12px;
    line-height: 36px;
  }

  .matching-box {
    width: calc(100% - 36px);
    height: 50px;
    margin: 22px auto 34px;
    font-size: 16px;
    line-height: 50px;
  }

  .upgrade-btn {
    min-height: 44px;
    font-size: 16px;
    line-height: 44px;
  }
}
</style>
